module.exports = __webpack_public_path__ + "static/media/161007-DSC05016-20_Small.a59324dd.jpg";